import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region VALID THROUGH

function _ValidThrough(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.ValidThrough)) {
        return null;
    }
    return <LabelValue {...props} value={props.content} />;
}
const ValidThrough = withLabelTokenParsing(_ValidThrough, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.ValidThrough)) {
                replaceString = data.ValidThrough;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Valid Through', token: Token.Date }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Valid Through:' })),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}}`, token: Token.Date }))
    }
};

// #endregion VALID THROUGH 

export {
    ValidThrough as Component,
    Tokens,
    TypeConfig
}